// Keystroke and cursor recording (Xiaohang, after quiz 1: to see whether pasted text was later
// rewritten). The code editor logs the classroom workspace's study events, CURSOR_SELECT and
// EDITOR_KEY, and the explanation box logs the same two; every edit in either logs GAP_EDIT
// with what changed and where, but not the full text (GAP_SNAPSHOT has that), and
// GAP_EDITOR_TEXT records the text each one opened with, so applying the edits in order to it
// gives every intermediate text. Each carries target 'code' or 'explanation'. KEYSTROKE_EVENTS
// are the ones a too-large keepalive batch may leave out.
export const KEYSTROKE_EVENTS = new Set(['GAP_EDIT', 'CURSOR_SELECT', 'EDITOR_KEY'])
export const CURSOR_DEBOUNCE_MS = 150

// The single changed range between two versions of a text: { from, to } in the old text and
// the text that replaced it.
export function textChange (before, after) {
  let start = 0
  const max = Math.min(before.length, after.length)
  while (start < max && before[start] === after[start]) start++
  let end = 0
  while (end < max - start && before[before.length - 1 - end] === after[after.length - 1 - end]) end++
  return { from: start, to: before.length - end, text: after.slice(start, after.length - end) }
}

// A long insert (a paste) keeps its first limit characters and its length. The same limit as
// CODE_PASTE's text; the full text is in the next GAP_SNAPSHOT.
const EDIT_TEXT_LIMIT = 4000
export const capChanges = (changes, limit = EDIT_TEXT_LIMIT) => changes.map(c => (c.text.length > limit
  ? { ...c, text: c.text.slice(0, limit), length: c.text.length, truncated: true }
  : c))

// Every string in a payload, nested ones too, cut to limit characters.
export const trimStrings = (value, limit) => {
  if (typeof value === 'string') return value.length > limit ? `${value.slice(0, limit)}…[trimmed]` : value
  if (Array.isArray(value)) return value.map(v => trimStrings(v, limit))
  if (value && typeof value === 'object') return Object.fromEntries(Object.entries(value).map(([k, v]) => [k, trimStrings(v, limit)]))
  return value
}

// A textarea's selection as CodeMirror reports one: anchor is where it started.
export const textareaSelection = el => (el.selectionDirection === 'backward'
  ? { anchor: el.selectionEnd, head: el.selectionStart }
  : { anchor: el.selectionStart, head: el.selectionEnd })
